var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2776,
    cy: 21.7112,
    r: 1.38889,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5284C13.4992 12.9769 13.6466 12.4364 13.9251 11.9692C14.2036 11.5021 14.6019 11.1275 15.074 10.8885C15.5461 10.6495 16.0728 10.5559 16.5933 10.6185C17.1138 10.6812 17.6068 10.8975 18.0155 11.2425C18.4242 11.5875 18.7319 12.0472 18.9031 12.5684C19.0742 13.0896 19.1019 13.6512 18.983 14.1883C18.864 14.7254 18.6032 15.2161 18.2306 15.6039C17.8581 15.9916 17.389 16.2605 16.8775 16.3796C16.7097 16.4144 16.5583 16.5089 16.4489 16.6473C16.3394 16.7857 16.2785 16.9595 16.2763 17.1395V18.007",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.1368bd8c.svg";
export { ForwardRef as ReactComponent };